<div class="docs-tab">
  @switch (navigator.view().kind) {
    @case ('folder') {
      <!-- Pasta do Data Room dentro do deal, sem iframe (PBI 3800): o mesmo componente da rota do mercado, com o
           navegador da aba. Voltar à raiz (seta ou trilha) volta para o Data Room da empresa desta aba. -->
      <section class="docs-tab__panel docs-tab__panel--embedded" role="tabpanel">
        <app-data-room-folder
          [folderId]="openFolderId()"
          [companyId]="companyId()"
          [dealView]="true"
          [triageUploader]="triageUploader()"
          dropScope="host" />
      </section>
    }
    @case ('completeness') {
      <!-- Completude embutida (decisão do Victor, PBI 3800); "Ver pasta" e "Enviar documento" ficam na aba e o
           "Abrir em nova aba" fica no cabeçalho dela, ao lado de Atualizar. -->
      <section class="docs-tab__panel docs-tab__panel--embedded" role="tabpanel">
        <app-company-completeness-page [companyId]="companyId()" />
      </section>
    }
    @default {
      <section class="docs-tab__data-room" role="tabpanel">
        <app-company-data-room
          [companyId]="companyId()"
          [restrictedView]="!visaoInterna()"
          [commercialDealView]="true"
          [triageUploader]="triageUploader()">
          <div dataRoomCrumbs class="docs-tab__crumb">
            <span>Data Room da empresa · solte os arquivos na _TRIAGEM e o Cog organiza</span>
            <!-- Pedido do Kit Banco ao cliente (card 3753): e-mail com Reply-To no endereço da empresa na caixa
                 de entrada do Data Room; a resposta com os anexos cai na _TRIAGEM. Fica na barra do Data Room
                 (card 3797) para a aba não ganhar uma linha só para ele. -->
            @if (canRequestBankKit()) {
              <!-- Mesmo desenho dos botões leves da barra (o "Societário" do app-company-data-room): o
                   app-button grande destoava da barra (card 3797). -->
              <button
                type="button"
                class="docs-tab__kit-btn"
                title="Mandar ao cliente o e-mail com a lista de documentos; a resposta dele entra direto no Data Room"
                (click)="openBankKitRequest()">
                <i class="pi pi-envelope" aria-hidden="true"></i> Solicitar Kit Banco
              </button>
            }
          </div>
        </app-company-data-room>
      </section>
    }
  }
</div>

<app-modal-bank-kit-request (requested)="bankKitRequested.emit()" />
